import { CoreSelect } from '@components'
import { getAccountingCategoryPaymentOptions } from '@constants'
import { useFeatureFlagState } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import type { UseFormValuesOutput } from 'mmfintech-commons/types'

interface AccountingCategorySelectProps {
  formValues: UseFormValuesOutput
}

const AccountingCategorySelect = ({ formValues }: AccountingCategorySelectProps) => {
  const accountingCategoryFF = useFeatureFlagState('WITHDRAW_ACCOUNTING_CATEGORY')

  return accountingCategoryFF.isEnabled ? (
    <CoreSelect
      type='default'
      name='accountingCategory'
      label={tr('FRONTEND.TRANSACTIONS.ACCOUNTING_CATEGORY', 'Payment category (optional)')}
      options={getAccountingCategoryPaymentOptions()}
      {...formValues.registerInput('accountingCategory')}
      data-test='accounting-category-select'
    />
  ) : null
}

export default AccountingCategorySelect
